class ScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

class CollectionListSwiper extends ScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    new Swiper(this, {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        700: {
          slidesPerView: 6,
          spaceBetween: 20
        }
      }
    })
  }
}

if (!window.customElements.get('collection-list-swiper')) {
  window.customElements.define('collection-list-swiper', CollectionListSwiper)
}

class VideoSwiper extends ScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    const swiperEle = this.querySelector('.swiper');
    new Swiper(swiperEle, {
      loop: false,
      spaceBetween: 30,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: this.getAttribute('data-swiper-center') === 'true' ? true : false,
      loop: true,
      
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1280: {
          slidesPerView: this.getAttribute('data-swiper-num'),
          spaceBetween: 30
        },
        1000: {
          slidesPerView: this.getAttribute('data-swiper-num'),
          spaceBetween: 30
        },
        700: {
          slidesPerView: 1,
          spaceBetween: 16,
        }
      }
    })

    const mediaBtn = this.querySelectorAll('.ystyle-media-box-item');
    const mediaPopup = this.querySelectorAll('.ystyle-media-box-popup');
    const mediaSection = this.querySelectorAll('.ystyle-media-box-section');
    const mediaClose = this.querySelectorAll('.ystyle-media-close');

    function toggleVideoPopup(index, action) {
      mediaPopup[index].classList[action]('hide');
      mediaSection[index].classList[action]('hide');
      mediaClose[index].classList[action]('hide');
      if(action === 'remove') {
        let innerHTML = mediaSection[index].innerHTML;
        mediaSection[index].innerHTML = innerHTML
      }
    }

    mediaBtn.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'remove');
        event.stopPropagation();
      });
    });

    mediaClose.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        toggleVideoPopup(index, 'add');
        event.stopPropagation();
      });
    });

    document.addEventListener('click', function (event) {
      const isClickedInsideBox = Array.from(mediaSection).some(box => box.contains(event.target));
      const isClickedInsideBtn = Array.from(mediaBtn).some(btn => btn.contains(event.target));

      if (!isClickedInsideBox && !isClickedInsideBtn) {
        mediaPopup.forEach((popup, index) => {
          // popup.classList.add('hide');
          toggleVideoPopup(index, 'add');
          event.stopPropagation();
        });
      }
    });
  }
}

if (!window.customElements.get('video-swiper')) {
  window.customElements.define('video-swiper', VideoSwiper)
}

class BlogSwiper extends ScriptLoader {
  constructor() {
    super()
    const url = this.getAttribute('data-load-script')
    this.loadScript(url, () => {
      this.init() // 调用自定义方法
    })
  }

  init() {
    new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

if (!window.customElements.get('blog-swiper')) {
  window.customElements.define('blog-swiper', BlogSwiper)
}

class AddToCart extends ScriptLoader {
  constructor() {
    super()
    this.clickBtn()
  }
  clickBtn() {
    // 这里放置自定义逻辑
    const AddBtn = document.querySelector('.shopify-section--main-product .product-info__buy-buttons button[type="submit"]') || this.parentNode.parentNode.parentNode.querySelector('.product-info__buy-buttons button[type="submit"]');
    this.addEventListener("click", function () {
      // Add to cart logic
      AddBtn.click();
    });
  }
}

class buyItNowBtn extends ScriptLoader {
  constructor() {
    super()
    this.addEventListener("click", function () {
      this.clickBtn()
    });
  }
  clickBtn() {
    // 这里放置自定义逻辑
    let buyBtn = document.querySelector('.shopify-section--main-product .product-info__buy-buttons .shopify-payment-button .shopify-payment-button__more-options') || this.parentNode.parentNode.parentNode.querySelector('.product-info__buy-buttons .shopify-payment-button .shopify-payment-button__more-options');

    if (!buyBtn) {
      requestAnimationFrame(this.clickBtn())
    } else {

      // Buy it now logic
      buyBtn.click();

    }
  }
}

if (!window.customElements.get('buy-it-now')) {
  window.customElements.define('buy-it-now', buyItNowBtn)
}

if (!window.customElements.get('add-to-cart')) {
  window.customElements.define('add-to-cart', AddToCart)
}

class Tab extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const ystyleProductTab = document.querySelectorAll('.ystyle-tab-frame li');
    const ystyleTabBox = document.querySelector('.ystyle-tab-section');
    const ystyleBtnBox = document.querySelector('.ystyle-tab-button');
    const ystyleBtn = document.querySelector('.ystyle-add-to-cart');
    const ystyleSectionList = document.querySelectorAll('#main .shopify-section');

    ystyleProductTab.forEach(function (e) {
      e.onclick = function () {
        // 获取点击项的data-point属性值
        let point = e.getAttribute('data-point');
        let number = e.getAttribute('data-section-number');
        // 遍历ystyleProductTab，移除所有激活类
        ystyleProductTab.forEach((a) => {
          a.classList.remove('active');
        });
        // 给当前点击项添加激活类
        e.classList.add('active');
        if (number) {
          // 通过属性值获取dom节点
          let pointDom = ystyleSectionList[number];
          // 计算滚动距离
          console.log(parseInt(ystyleTabBox.style.top), ystyleTabBox.getBoundingClientRect().height, pointDom.offsetTop);
          let pointTop =
            pointDom.offsetTop - parseInt(ystyleTabBox.style.top) - ystyleTabBox.getBoundingClientRect().height - 30;
          // 滑动到指定dom节点
          window.scrollTo({
            top: pointTop,
            behavior: 'smooth',
          });
        }
      };
    });
    // 添加点击事件监听器
    ystyleBtn.addEventListener('click', function () {
      // 模拟点击加入购物车按钮
      // 这里假设加入购物车按钮的类名为"button--secondary"
      // 你可以根据实际情况修改
      let addToCart = document.querySelector('.button--secondary[is="custom-button"]');
      addToCart.click();
    });
    let scrollTimer;

    // 添加滚动事件监听器
    window.addEventListener('scroll', function () {
      // 清除之前的定时器
      clearTimeout(scrollTimer);

      // 设置新的定时器
      scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        const headerSection = document.querySelector('header.shopify-section--header');
        let { height, top } = headerSection.getBoundingClientRect();
        // 剩下的代码保持不变
        if (headerSection) {
          let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;

          ystyleTabBox.style.top = btnBoxTop + 'px';

          if (ystyleTabBox.getBoundingClientRect().top <= btnBoxTop) {
            ystyleBtnBox.style.width = '340px';
          } else {
            ystyleBtnBox.style.width = 0;
          }
        }
      }, 250); // 这里的 250 是延迟时间，单位为毫秒
    });

    const variantBlock = document.querySelector('.variant-picker');
    const priceEle = this.querySelector('.price-list')
    variantBlock.addEventListener('click', (event) => {
      if (event.target !== variantBlock) {
        console.log(priceEle);
        setTimeout(() => {
          const newElement = document.querySelector('.product-info .price-list')
          priceEle.innerHTML = newElement.innerHTML
        }, 1000);
      }
    })
  }
}

if (!window.customElements.get('ystyle-tab')) {
  window.customElements.define('ystyle-tab', Tab)
}

class Nav extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const ystyleProductTab = document.querySelectorAll('.ystyle-nav-frame li');
    const ystyleTabBox = document.querySelector('.ystyle-nav-section');
    const ystyleBtnBox = document.querySelector('.ystyle-nav-button');
    const ystyleBtn = document.querySelector('.ystyle-add-to-cart');
    let ystyleSectionList = Array.from(document.querySelectorAll('#main .shopify-section'));

    // 过滤除产品详情组件、导航组件元素本身、页脚
    ystyleSectionList = ystyleSectionList.filter((item) => {
      return !item.contains(this)
      && !item.classList.contains('shopify-section--main-product')
      && !item.classList.contains('shopify-section-group-footer-group')
    })


    this.addDisplayNone(ystyleSectionList);
    // 默认点击第一个选项
    this.clickElement(ystyleProductTab[0], ystyleSectionList);

    const _this = this;
    ystyleProductTab.forEach(function (e) {
      e.onclick = function () {
        // 遍历ystyleProductTab，移除所有激活类
        ystyleProductTab.forEach((a) => {
          a.classList.remove('active');
        });
        // 给当前点击项添加激活类
        e.classList.add('active');
        _this.addDisplayNone(ystyleSectionList);
        _this.clickElement(e, ystyleSectionList);
      };
    });

    // 添加点击事件监听器
    ystyleBtn.addEventListener('click', function () {
      // 模拟点击加入购物车按钮
      // 这里假设加入购物车按钮的类名为"button--secondary"
      // 你可以根据实际情况修改
      let addToCart = document.querySelector('.button--secondary[is="custom-button"]');
      addToCart.click();
    });

    let scrollTimer;

    // 添加滚动事件监听器
    window.addEventListener('scroll', function () {
      // 清除之前的定时器
      clearTimeout(scrollTimer);

      // 设置新的定时器
      scrollTimer = setTimeout(function () {
        // 在页面滚动停止后执行的操作
        const headerSection = document.querySelector('header.shopify-section--header');
        let { height, top } = headerSection.getBoundingClientRect();
        // 剩下的代码保持不变
        if (headerSection) {
          let btnBoxTop = height + top >= 0 ? height - 1 + top : 0;

          ystyleTabBox.style.top = btnBoxTop + 'px';

          if (ystyleTabBox.getBoundingClientRect().top <= btnBoxTop) {
            ystyleBtnBox.style.width = '340px';
          } else {
            ystyleBtnBox.style.width = 0;
          }
        }
      }, 250); // 这里的 250 是延迟时间，单位为毫秒
    });

    const variantBlock = document.querySelector('.variant-picker');
    const priceEle = this.querySelector('.price-list')
    variantBlock.addEventListener('click', (event) => {
      if (event.target !== variantBlock) {
        setTimeout(() => {
          const newElement = document.querySelector('.product-info .price-list')
          priceEle.innerHTML = newElement.innerHTML
        }, 1000);
      }
    })
  }

  addDisplayNone(arr) {
    arr.forEach((item) => {
      item.classList.remove('display-none')
      item.classList.add('display-none');
    })
  }

  clickElement(ele, sectionList) {
    const sectionsArr = ele.getAttribute('data-include-section').split(',');
    sectionsArr.forEach((str) => {
      sectionList[parseInt(str) - 1]?.classList.remove('display-none');
    })
  }
}

if (!window.customElements.get('ystyle-nav')) {
  window.customElements.define('ystyle-nav', Nav)
}

class megaMenu2 extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const image_block = this.querySelector('.ystyle-hover-image');
    const li_list = this.querySelectorAll('.grand-menu-item');

    
    const template = li_list[0].querySelector('template');

    if (template) {
      const clone = template.content.cloneNode(true);
      image_block.innerHTML = '';
      image_block.appendChild(clone);
    }

    li_list.forEach(item => {
      item.addEventListener('mouseenter', () => {
        const template = item.querySelector('template');
        
        if (template) {
          const clone = template.content.cloneNode(true);
          image_block.innerHTML = '';
          image_block.appendChild(clone);
        }
      }, false)
    })
  }
}

if (!window.customElements.get('ystyle-mega-menu-2')) {
  window.customElements.define('ystyle-mega-menu-2', megaMenu2)
}

document.addEventListener('DOMContentLoaded', () => {
  let active_id;
  const top_arrow = document.querySelector('.product-gallery--desktop-thumbnails-left .ystyle-top-arrow');
  const bottom_arrow = document.querySelector('.product-gallery--desktop-thumbnails-left .ystyle-bottom-arrow');
  const thumbnail_list = document.querySelectorAll('.product-gallery--desktop-thumbnails-left page-dots button.product-gallery__thumbnail');
  if(top_arrow) {
    top_arrow.classList.add('disabled');
  }

  if (top_arrow && bottom_arrow) {
    top_arrow.addEventListener('click', () => {
    
      thumbnail_list.forEach((item, index) => {
        if(item.getAttribute('aria-current') === 'true') {
          active_id = index - 1;
        }
      })
      thumbnail_list[active_id].click();
    })

    bottom_arrow.addEventListener('click', () => {
      thumbnail_list.forEach((item, index) => {
        if(item.getAttribute('aria-current') === 'true') {
          active_id = index + 1;
        }
      })
      thumbnail_list[active_id].click();
    })

    document.addEventListener('carousel:change', (event) => {
      if (event.detail.index === 0) {
        top_arrow.classList.add('disabled')
      } else if (event.detail.index === thumbnail_list.length - 1) {
        bottom_arrow.classList.add('disabled')
      } else {
        if (top_arrow.classList.contains('disabled')) {
          top_arrow.classList.remove('disabled')
        }
        if (bottom_arrow.classList.contains('disabled')) {
          bottom_arrow.classList.remove('disabled')
        }
      }
    })
  }
})